module.exports = __webpack_public_path__ + "img/login_tip_lishu.4bb32fd2.png";